import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(({ palette, typography }) => ({
  root: {
    borderRadius: 24,
    boxShadow: `0 4px 8px ${palette.text.disabled}`,
    fontSize: typography.pxToRem(16),
    height: 40,
    width: 40,
    minWidth: 40,
    lineHeight: typography.pxToRem(16),
    padding: 0,
    '&:disabled': {
      color: palette.common.white
    }
  },
  label: {
    textTransform: 'initial',
    width: 20
  },
  startIcon: {
    margin: 0
  },
  iconSizeSmall: {
    fontSize: typography.pxToRem(16)
  },
  iconSizeMedium: {
    fontSize: typography.pxToRem(16)
  },
  iconSizeLarge: {
    fontSize: typography.pxToRem(16)
  }
}))(Button);
